import { ScreenPoint, WorldPoint } from "../../geo/types";

export class Camera2D {
  offsetX = 0;
  offsetY = 0;
  zoom = 1;
  minZoom = 0.5;
  maxZoom = 6;

  apply(ctx: CanvasRenderingContext2D): void {
    ctx.transform(this.zoom, 0, 0, this.zoom, this.offsetX, this.offsetY);
  }

  panBy(dx: number, dy: number): void {
    this.offsetX += dx;
    this.offsetY += dy;
  }

  screenToWorld(point: ScreenPoint): WorldPoint {
    return {
      x: (point.x - this.offsetX) / this.zoom,
      y: (point.y - this.offsetY) / this.zoom,
    };
  }

  zoomAt(screenPoint: ScreenPoint, zoomFactor: number): void {
    const clamped = Math.max(
      this.minZoom,
      Math.min(this.maxZoom, this.zoom * zoomFactor),
    );
    const worldBefore = this.screenToWorld(screenPoint);
    this.zoom = clamped;
    this.offsetX = screenPoint.x - worldBefore.x * this.zoom;
    this.offsetY = screenPoint.y - worldBefore.y * this.zoom;
  }

  fitToBounds(
    bounds: { minX: number; minY: number; maxX: number; maxY: number },
    viewport: { width: number; height: number },
    padding = 24,
  ): void {
    const width = Math.max(1, bounds.maxX - bounds.minX);
    const height = Math.max(1, bounds.maxY - bounds.minY);
    const zoomX = (viewport.width - padding * 2) / width;
    const zoomY = (viewport.height - padding * 2) / height;
    this.zoom = Math.max(
      this.minZoom,
      Math.min(this.maxZoom, Math.min(zoomX, zoomY)),
    );
    this.offsetX = padding - bounds.minX * this.zoom;
    this.offsetY = padding - bounds.minY * this.zoom;
  }
}
